import { createContext, type ReactNode, useState } from 'react';

export type SectionProviderProps = {
  children: ReactNode;
  initial?: NavigationDetails;
};

export type NavigationDetails = {
  part: number;
  section: number;
  subSection: number;
};

export const SectionContext = createContext<{
  part: number;
  section: number;
  setNavigationDetails: (navigationDetails: NavigationDetails) => void;
  subSection: number;
}>({
  part: 0,
  section: 0,
  setNavigationDetails: () => {},
  subSection: 0,
});

export const SectionProvider = ({
  children,
  initial,
}: SectionProviderProps) => {
  const [{ part, section, subSection }, setNavigationDetails] =
    useState<NavigationDetails>(
      initial || { part: 0, section: 0, subSection: 0 },
    );

  return (
    <SectionContext.Provider
      value={{
        part,
        section,
        setNavigationDetails,
        subSection,
      }}
    >
      {children}
    </SectionContext.Provider>
  );
};
